import axios from '@axios'

const route = 'manager_room'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAllRoom() {
      return axios.get(`${route}/get_all`)
    },
    checkIn(context, room) {
      return axios.post(`${route}/check_in`, room)
    },
    walkIn(context, room) {
      return axios.post(`${route}/walk_in`, room)
    },
    update(context, room) {
      return axios.put(`${route}/${room.id}`, room)
    },
    delete(context, role) {
      return axios.delete(`${route}/${role.id}`)
    },
  },
}
